// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cd0bee46","667":"48b13657"}[chunkId] + ".chunk.js";
};